import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Base64 } from 'base64-string';
import _ from "lodash";
import { ProjectService } from "../../../core/services/project/project.service";
import { RestService } from "../../../core/services/rest.service";
import { ToasterService } from "../../../core/services/toaster-service";
import { selfHealedObjectColumns } from "../../../core/table-templates/self-healed-objects-table";
import { MessageEnum } from "../../../core/utils/message.enum";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";

@Component({
  selector: "app-self-healed-objects-modal",
  standalone: true,
  imports: [CommonModule, ZorroTableComponent],
  templateUrl: "./self-healed-objects-modal.component.html",
  styleUrl: "./self-healed-objects-modal.component.scss",
})
export class SelfHealedObjectsModalComponent implements OnInit {
  @Input()
  data: any[] = [];

  isActive: boolean = false;

  @Input()
  executionInstanceTaskId: string = "";

  activeModal = inject(NgbActiveModal);
  columns: any = _.cloneDeep(selfHealedObjectColumns);
  projectId: any;
  automationProjectId: any;

  constructor(
    private restService: RestService,
    private projectService: ProjectService,
    private readonly toaster: ToasterService
  ) {}

  ngOnInit(): void {
    this.projectService.getProjectId().subscribe((id) => {
      this.projectId = id;
    });
    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectId = id;
    });
  }


  onRowHandle(params: any) {
    console.log(params);
    const enc = new Base64();
    if (params?.type === "button") {
      delete params?.data?.row?.level;
      delete params?.data?.row?.expand;
      params.data.row.newLocator = enc.encode(params.data.row.newLocator);
      params.data.row.oldLocator = enc.encode(params.data.row.oldLocator);
      const paylolad = {
        executionInstanceTaskId: this.executionInstanceTaskId,
        selfHealObjects: [{...params?.data?.row}],
      };

      this.restService
        .saveSelfhealedObjects(
          this.projectId,
          this.automationProjectId,
          paylolad
        )
        .subscribe(
          (item) => {
            if (item) {
              params.data.row.saved = true;
              this.toaster.pop({ type: 'success', text: MessageEnum.SELF_HEALED_OBJECT_SAVE_SUCCESS });
            }
          },
          (error) => {
            this.toaster.pop({ type: 'error', text: MessageEnum.SELF_HEALED_OBJECT_SAVE_FAILURE });
          }
        );
    }
  }

  dismiss() {
    this.activeModal.dismiss("Dismissed by user");
  }
}
